let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bLXUG")).then(() => parcelRequire('7xB1Z'));